var Vendd = (function (Vendd) {
	'use strict';

	Vendd.Scripts = (function () {
		var scripts = [];

		return {
			load: function (fn) {
				scripts.push(fn);
			},

			init: function () {
			    _.each(scripts, function (fn) {
					fn();
			    });

			    callback_vendd();
			}
		};
	})();

	return Vendd;

})(Vendd || {});